import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { Constant } from 'src/app/Common/constant';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { ErrorLog } from 'src/app/Model/Common/error-log';
import { AllDeliveryDetailsDto } from 'src/app/Model/Shipping/all-delivery-details-dto';
import { AssignShippingDto } from 'src/app/Model/Shipping/assign-shipping-dto';
import { ReasonsOfCancellation } from 'src/app/Model/Shipping/reasons-of-cancellation';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';


@Component({
  selector: 'shipping-status',
  templateUrl: './shipping-status.component.html',
  styleUrls: ['./shipping-status.component.css']
})
export class ShippingStatusComponent implements OnInit, OnDestroy {

  shipping: AllDeliveryDetailsDto;
  shippingStatusForm: UntypedFormGroup;
  assignShippingDto: AssignShippingDto = new AssignShippingDto();
  constant: Constant = new Constant();
  reasonsOfPickupCancel: ReasonsOfCancellation[] = [];
  reasonsOfReschedule: ReasonsOfCancellation[] = [];
  reasonsOfCancellation: ReasonsOfCancellation[] = [];
  errorLog: ErrorLog = new ErrorLog();

  today: Date = new Date();

  //Subscription
  private saveShippingSubscription: Subscription;
  private reasonOfPickupCancellationSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private formBuilder: UntypedFormBuilder,
    private toastService: ToastrService,
    public persistenceService: LocalStorageService,
    private shippingManagerService: ShippingManagerService,
    private apiFactory: APIFactoryEndPoints,
    public dialogRef: MatDialogRef<ShippingStatusComponent>,
  ) {
    this.shipping = dialogData.shippingData;
    console.log(this.shipping);
  }

  ngOnInit(): void {
    this.createStatusForm();
    if (this.shipping)
      this.setUserEditForm();
  }

  ngOnDestroy() {
    if (this.saveShippingSubscription !== undefined)
      this.saveShippingSubscription.unsubscribe();

    if (this.reasonOfPickupCancellationSubscription !== undefined)
      this.reasonOfPickupCancellationSubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
  }

  getReasonOfPickupCancellation() {
    this.reasonOfPickupCancellationSubscription = this.shippingManagerService.getReasonOfPickupCancellation(this.apiFactory.getReasonOfPickupCancellation).subscribe(data => {
      this.reasonsOfPickupCancel = data;
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getReasonOfPickupCancellation", error);
      });
  }

  getReasonOfRescheduling() {
    this.reasonOfPickupCancellationSubscription = this.shippingManagerService.getReasonOfPickupCancellation(this.apiFactory.getReasonOfRescheduling).subscribe(data => {
      this.reasonsOfReschedule = data;
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getReasonOfRescheduling", error);
      });
  }

  getReasonOfCancellation() {
    this.reasonOfPickupCancellationSubscription = this.shippingManagerService.getReasonOfCancellation(this.apiFactory.getReasonOfCancellation, "Shipping").subscribe(data => {
      this.reasonsOfCancellation = data;
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getReasonOfCancellation", error);
      });
  }

  createStatusForm() {
    this.shippingStatusForm = this.formBuilder.group({
      locationName: [],
      noOfProducts: [],
      qty: [],
      packets: [],
      reasonCode: [],
      rescheduleDate: [],
      rescheduleTime: [],
      notes: [],
    });
  }

  setUserEditForm() {
    this.shippingStatusForm.patchValue({
      locationName: this.shipping.locationName,
      noOfProducts: this.shipping.noOfProducts,
      qty: this.shipping.qty,
      packets: this.shipping.assignedDeliveryDto?.noOfPackets
    })
    if (this.shipping.shippingStatus == this.constant.DELIVERY_PICK_UP_CANCELLED)
      this.getReasonOfPickupCancellation();
    else if (this.shipping.shippingStatus == this.constant.DELIVERY_RESCHEDULE)
      this.getReasonOfRescheduling();
    else if (this.shipping.shippingStatus == this.constant.DELIVERY_CANCEL)
      this.getReasonOfCancellation();

  }

  saveClick() {
    if (this.shipping.shippingStatus == this.constant.DELIVERY_PICK_UP) {
      if (!this.shippingStatusForm.get('packets').value) {
        this.shippingStatusForm.get('packets').setValidators(Validators.required);
        this.toastService.showErrorToast(this.constant.invalidFormToast);
        return;
      }
    }
    if (this.shipping.shippingStatus == this.constant.DELIVERY_PICK_UP_CANCELLED) {
      if (!this.shippingStatusForm.get('packets').value || !this.shippingStatusForm.get('reasonCode').value) {
        this.shippingStatusForm.get('packets').setValidators(Validators.required);
        this.shippingStatusForm.get('reasonCode').setValidators(Validators.required);
        this.toastService.showErrorToast(this.constant.invalidFormToast);
        return;
      }
    }
    if (this.shipping.shippingStatus == this.constant.DELIVERY_RESCHEDULE) {
      if (!this.shippingStatusForm.get('reasonCode').value || !this.shippingStatusForm.get('rescheduleDate').value
        || !this.shippingStatusForm.get('rescheduleTime').value) {
        this.shippingStatusForm.get('reasonCode').setValidators(Validators.required);
        this.shippingStatusForm.get('rescheduleDate').setValidators(Validators.required);
        this.shippingStatusForm.get('rescheduleTime').setValidators(Validators.required);
        this.toastService.showErrorToast(this.constant.invalidFormToast);
        return;
      }
    }
    if (this.shipping.shippingStatus == this.constant.DELIVERY_CANCEL) {
      if (!this.shippingStatusForm.get('reasonCode').value) {
        this.shippingStatusForm.get('reasonCode').setValidators(Validators.required);
        this.toastService.showErrorToast(this.constant.invalidFormToast);
        return;
      }
    }

    this.assignShippingDto.transactionNo = this.shipping.assignedDeliveryDto.invNo;
    this.assignShippingDto.transactionName = this.shipping.assignedDeliveryDto.transType;
    this.assignShippingDto.serviceManCode = this.shipping.assignedDeliveryDto.serviceManCode;
    this.assignShippingDto.fromLocationCode = this.shipping.locationCode;
    this.assignShippingDto.noOfPacket = this.shippingStatusForm.get('packets').value;
    this.assignShippingDto.reasonCode = this.shippingStatusForm.get('reasonCode').value;
    this.assignShippingDto.notes = this.shippingStatusForm.get('notes').value;
    if (this.shipping.shippingStatus == this.constant.DELIVERY_RESCHEDULE) {
      let date = new Date(this.shippingStatusForm.get('rescheduleDate').value);
      let formattedDate = moment(date).format(this.constant.dateFormatForDBServer);
      let time = this.shippingStatusForm.get('rescheduleTime').value;
      let deliveryDate = formattedDate + " " + time;
      this.assignShippingDto.deliveryDate = deliveryDate;
      this.assignShippingDto.deliverySlot = time;
    } else {
      this.assignShippingDto.deliveryDate = moment(this.shipping.assignedDeliveryDto.deliveryDate).format("YYYY-MM-DD HH:mm");
      this.assignShippingDto.deliverySlot = this.shipping.assignedDeliveryDto.slot;
    }
    if (this.shipping.shippingStatus == this.constant.DELIVERY_PICK_UP)
      this.assignShippingDto.status = this.constant.DELIVERY_PICK_UP;
    else if (this.shipping.shippingStatus == this.constant.DELIVERY_PICK_UP_CANCELLED)
      this.assignShippingDto.status = this.constant.DELIVERY_PICK_UP_CANCELLED;
    else if (this.shipping.shippingStatus == this.constant.DELIVERY_RESCHEDULE)
      this.assignShippingDto.status = this.constant.DELIVERY_RESCHEDULE;
    else if (this.shipping.shippingStatus == this.constant.DELIVERY_CANCEL)
      this.assignShippingDto.status = this.constant.DELIVERY_CANCEL;

    this.saveShippingSubscription = this.shippingManagerService.saveShipping(this.apiFactory.insertShipping, this.assignShippingDto).subscribe((data: any) => {
      if (data != null) {
        console.log(data)
        this.toastService.showSuccessToast(this.assignShippingDto.status + " Sucessfully");
        this.dialogRef.close(data);
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("saveClick", error);
      });
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "Shipping Manager";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = "Web";
    if (error?.error?.message|| error?.error?.message!= '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    // this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiFactory.insertErrorLog, this.errorLog).subscribe((data: any) => {
    // });
  }
}
